import './styles.scss';

import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CircularProgress, Modal } from '@mui/material';
import { useContext, useEffect } from 'react';

import { VenueContext } from '../../../../providers/venue-provider';

interface IProps {
  open: boolean;
  handleClose: () => void;
  account?: string;
}

const DeleteAccountModal = ({ open, handleClose, account }: IProps) => {
  const { deleteAccount, isLoading, isSuccess } = useContext(VenueContext);

  const handleDeleteAccount = () => {
    if (account) {
      deleteAccount(account);
    }
  };

  useEffect(() => {
    if (!isLoading && isSuccess) {
      handleClose();
    }
  }, [handleClose, isLoading, isSuccess]);

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="delete-account-modal-container">
        <div className="delete-account-modal-content">
          <div className="header">
            <h1>Are you sure you want to delete it?</h1>
            <Button className="close-button" onClick={handleClose}>
              <FontAwesomeIcon icon={faX} />
            </Button>
          </div>

          <div className="description">
            <p>
              Unbind your API will delete all your historical PnL, order history and trading
              history.
            </p>
            <p>
              This action will affect all relative portfolios including this account on Immersive
              Finance, and these portfolios will be kept by default - only if this account is not
              the only one in the portfolio, otherwise the portfolio will also be deleted.
            </p>
          </div>

          <div className="buttons">
            <Button className="bt cancel-button" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="bt confirm-button" onClick={handleDeleteAccount}>
              {isLoading ? <CircularProgress size={24} /> : <span>Delete anyway</span>}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAccountModal;
